import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { Title } from './ContentSlice';

import { fieldHasContent, transformProperties } from '@/src/domains/prismic/helpers';
import { desktopBreakpoint } from '@/src/domains/shared/breakpoints';

const Section = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '70px', '138px')}
  font-family: var(--typography-fontBrand);
  position: relative;
  background-color: var(--newBrandColor);
  overflow: hidden;
  max-height: 358px;
`;

const Content = styled.div`
  z-index: 1;
  position: relative;

  ${desktopBreakpoint(css`
    padding-left: 50px;
  `)};
`;

const TitleComponent = styled(Title)`
  color: var(--colors-blank);
  max-width: 960px;
`;

export function MoreInformationSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, sectionId } = primary;

  const defaultTitle = `Remote’s Benefits Practices`;

  return (
    <Section id={sectionId}>
      <ContentContainer>
        <Content>
          <TitleComponent>
            {fieldHasContent(title) ? <PrismicRichText field={title} /> : defaultTitle}
          </TitleComponent>
        </Content>
      </ContentContainer>
    </Section>
  );
}
